export default __webpack_public_path__ + "static/media/background.83d0df1d.jpg";